import React from 'react';

const ReelImage = ({ filename, alt, className = '', onError }) => {
  const handleError = (e) => {
    if (onError) {
      onError(e);
    }
    // Set a placeholder or default image on error
    e.target.style.backgroundColor = '#f0f0f0';
    e.target.style.display = 'flex';
    e.target.style.alignItems = 'center';
    e.target.style.justifyContent = 'center';
    e.target.innerHTML = '이미지 없음';
  };

  const imageSrc = filename ? `/data/img/reels/${filename}` : '/data/img/reels/placeholder.png';

  return (
    <img 
      src={imageSrc}
      alt={alt || 'Reel image'}
      className={className}
      onError={handleError}
    />
  );
};

export default ReelImage;
